import React, { useState } from 'react';
import '../../styles/AdminModal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import useLeadActions from '../../hooks/AdminLeadsPage/useLeadActions';

const LeadsBulkDeleteModal = ({ isOpen, onClose, onSuccess, leads }) => {
  const [loading, setLoading] = useState(false);
  const { handleBulkDelete } = useLeadActions();

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await handleBulkDelete(leads);
      await onSuccess();
      onClose();
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="admin__modal">
      <div className="admin__modal-content">
        <div className="admin__modal-intro">
          <h2>Delete Leads</h2>
          <button className="admin__modal-close" onClick={onClose}>
            <FontAwesomeIcon icon={faClose} />
          </button>
        </div>
        <div className="admin__modal-body">
          <div className="admin__modal-body__delete_items">
            <p>
              Are you sure you want to delete the following {leads.length} {leads.length === 1 ? 'lead' : 'leads'}?
            </p>
            <div className="admin__modal-body__delete_items_container">
              <ul>
                {leads.map(lead => (
                  <li key={lead.id}>
                    <strong>{lead.full_name}</strong> (ID #{lead.id}, Email: {lead.email})
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="admin__modal-buttons">
          <button className="button secondary" onClick={onClose} disabled={loading}>
            {loading ? 'Processing...' : 'Cancel'}
          </button>
          <button className="button" onClick={handleConfirm} disabled={loading}>
            {loading ? 'Processing...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeadsBulkDeleteModal;